<script>
export default {
  name: "StudentSpeakingSubmission",
  props: {
    currenMarkingData: {
      type: Object,
      default: null
    },
    autoplay: {
      type: Boolean,
      default: false
    },
  },
  data(){
    return {
      currentIndex: 0
    }
  },
  computed:{
    currentAudio(){
      if(!this.currenMarkingData?.questionsAndAnswers || this.currenMarkingData?.questionsAndAnswers.length === 0 ){
        return  ''
      }
      return this.currenMarkingData?.questionsAndAnswers[this.currentIndex]?.answer
    },
    currentQuestion(){
      if(!this.currenMarkingData?.questionsAndAnswers || this.currenMarkingData?.questionsAndAnswers.length === 0 ){
        return  ''
      }
      return this.currenMarkingData?.questionsAndAnswers[this.currentIndex]?.content
    }
  },
  mounted() {
    this.playCurrentAudio()
  },
  methods:{
    playCurrentAudio() {
      if (!this.autoplay || !this.currentAudio) return

      this.$nextTick(() => {
        const audio = this.$refs.audioPlayer
        if (!audio) return

        const startPlayback = () => {
          audio.currentTime = 0
          audio.muted = true
          audio.play()
            .then(() => {
              audio.muted = false
            })
            .catch(err => {
              console.warn('Auto-play failed:', err)
            })
        }

        if (audio.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) {
          startPlayback()
        } else {
          audio.addEventListener('canplay', startPlayback, {once: true})
          audio.load()
        }
      })
    },
    changeQuestion(questionIndex){
      this.currentIndex = questionIndex
      this.$nextTick(() => {
        const audio = this.$refs.audioPlayer
        if (audio) {
          audio.pause()
          audio.currentTime = 0
          audio.load()
          if (this.autoplay) {
            audio.play().catch(err => {
              console.warn('Auto-play failed:', err)
            })
          }
        }
      })
    }
  }
}
</script>

<template>
  <div style="background-color: #F8F8F8;" class="p-5">
    <div class="step-container">
      <div
        v-for="(question,questionIndex) in currenMarkingData.questionsAndAnswers"
        :class="currentIndex === questionIndex? 'step-active' : 'step-circle'"
        @click="changeQuestion(questionIndex)" class="step" :key="question?.id">
        {{questionIndex + 1}}
      </div>
    </div>
    <p class="mt-5" v-html="currentQuestion"></p>
    <p class="mt-5 " style="font-weight: bold ; font-size: 15px">Câu trả lời của học viên</p>
    <audio ref="audioPlayer" controls class="mt-5 ">
      <source :src="currentAudio" type="audio/ogg">
      <source :src="currentAudio" type="audio/mpeg">
      Your browser does not support the audio element.
    </audio>
  </div>
</template>

<style scoped>
.step {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  text-align: center;
  line-height: 35px;
  font-weight: bold;
  cursor: pointer;
}
.step-circle {
  background-color: #dcdcdc; /* xám nhạt */
  color: #000;
}

.step-active {
  background-color: #007bff !important; /* xanh dương */
  color: #fff !important;
}

.step-container {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  align-items: center;
  overflow: auto;
  width: 100%;
}
</style>
